import { translationModeration_da } from "./translationModeration.da";
import { translationModeration_en } from "./translationModeration.en";
import { defineBilingualTranslations } from "./translationTypes";

/** Moderation flags, visitor blocks and the Blocked visitors page. */
export const translationModeration = defineBilingualTranslations({
  da: translationModeration_da,
  en: translationModeration_en,
});
